/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./nls/StringResources'
], function(ServiceabilityStringResources){
	class ServiceabilityDataSource{
		constructor(visualizationAPI) {
			this._visualizationAPI = visualizationAPI;
			this._dataSource = this._visualizationAPI.getDataSource();
			this._initializeInfo();
		}

		/**
		 * @returns {object} The result of this result should be an object which will
		 * be stringfied later.
		 * @description this method will fetch the data source info of a live widget
		 * through the APIs.
		 */
		toJSON() {
			this._dataSource = this._visualizationAPI.getDataSource();
			this._updateInfo();
			return this._json;
		}

		/**
		 * @description this method will fetch the data mapping info and construct a UI spec which defined
		 * how the Data Mapping section will be displayed
		 * @returns {object} The UI spec which will be consumed by ContentInfoAPI
		 */
		toUIJSON() {
			const json = this.toJSON();
			return [{
				fieldName: ServiceabilityStringResources.get('dataSourceName'),
				fieldValue: json.dataSourceInfo.name
			}, {
				fieldName: ServiceabilityStringResources.get('dataSourceId'),
				fieldValue: json.dataSourceInfo.id
			}, {
				fieldName: ServiceabilityStringResources.get('dataSourcePath'),
				fieldValue: json.dataSourceInfo.path
			}, {
				fieldName: ServiceabilityStringResources.get('dataSourceType'),
				fieldValue: json.dataSourceInfo.type
			}];
		}

		_initializeInfo() {
			this._resetInfo();
			this._updateInfo();
		}

		_resetInfo() {
			this._json = {
				dataSourceInfo: {
					name: ServiceabilityStringResources.get('infoNotAvailable'),
					id: ServiceabilityStringResources.get('infoNotAvailable'),
					path: ServiceabilityStringResources.get('infoNotAvailable'),
					type: ServiceabilityStringResources.get('infoNotAvailable')
				}
			};
		}

		_updateInfo() {
			if (this._dataSource) {
				if (this._dataSource.getAssetId() !== this._json.dataSourceInfo.id) {
					this._fetchAttributes();
				}
			} else {
				this._resetInfo();
			}
		}

		/**
		 * Fetch async values that we want to show in the serviceability panel
		 * Note: 	These will be populated when available. If not available and user opens
		 * 			the serviceability panel, they will see blank value
		 */
		_fetchAttributes() {
			this._json.dataSourceInfo.id = this._dataSource.getAssetId();
			this._json.dataSourceInfo.type = this._dataSource.getType();
			this._dataSource.getLocalizedName().then((name) => {
				this._json.dataSourceInfo.name = name;
			});
			this._dataSource.getSearchPath().then((path) => {
				this._json.dataSourceInfo.path = path;
			});
		}
	}
	return ServiceabilityDataSource;
});
